import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { TelefonosFormComponent } from './telefonos/components/telefonos-form.component';
import { DatosContactoFormComponent } from './datos-contacto/datos-contacto-form/datos-contacto-form.component';

@NgModule({
  declarations: [TelefonosFormComponent, DatosContactoFormComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [CommonModule, SharedModule],
  exports: [TelefonosFormComponent, DatosContactoFormComponent]
})
export class ContactosModule {}
